import { render, staticRenderFns } from "./ReadyLicense.vue?vue&type=template&id=0d1460db&scoped=true&"
import script from "./ReadyLicense.vue?vue&type=script&lang=js&"
export * from "./ReadyLicense.vue?vue&type=script&lang=js&"
import style0 from "./ReadyLicense.vue?vue&type=style&index=0&id=0d1460db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1460db",
  null
  
)

export default component.exports